{
  "language": {
    "title": "Wählen Sie Ihre Sprache",
    "en": "Englisch",
    "nl": "Niederländisch",
    "sr": "Serbisch",
    "fr": "Französisch",
    "de": "Deutsch",
    "pt": "Portugiesisch"
  },
  "home": {
    "welcomeMessage": "Hallo, was führt Sie heute hierher?",
    "checkIn": "Einchecken",
    "independentManualCheckIn": "Kein Termin",
    "integratedManualCheckIn": "Manuell einchecken",
    "checkOut": "Auschecken",
    "manualCheckOut": "Manuell auschecken",
    "parcelDelivery": "Paketlieferung",
    "foodDelivery": "Essenslieferung",
    "callReception": "Rezeption anrufen",
    "overview": "Übersicht",
    "unavailable": "Die Rezeption ist derzeit nicht verfügbar."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Wählen Sie eine Option zum Einchecken",
        "manual": "Manuell einchecken",
        "code": "Mit PIN/QR-Code einchecken"
      },
      "checkout": {
        "title": "Wählen Sie eine Option zum Auschecken",
        "manual": "Mit Namen auschecken",
        "code": "Mit PIN/QR-Code auschecken"
      }
    },
    "title": "Warten auf das Scannen Ihres QR-Codes.<br/>Kein QR-Code? Kein Problem.",
    "orText": "ODER",
    "qrScanner": {
      "checkin": {
        "title": "Wählen Sie eine Option zum Einchecken"
      },
      "checkout": {
        "title": "Wählen Sie eine Option zum Auschecken"
      },
      "btn": "Scannen Sie Ihren QR-Code"
    },
    "pinCode": "Geben Sie Ihren PIN-Code ein",
    "manually": {
      "checkin": "Keine Anmeldedaten?"
    },
    "status": {
      "idle": {
        "title": "Ihr Code wird gescannt.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Ihr Code wird gescannt.",
        "message": "Bitte warten..."
      },
      "error": {
        "title": "Ihr Code ist ungültig.",
        "message": "Bitte versuchen Sie es erneut!"
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Sie haben erfolgreich eingecheckt.",
            "message": "Danke."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Sie haben erfolgreich eingecheckt.",
              "message": "Danke."
            },
            "email-sms": {
              "title": "Sie haben erfolgreich eingecheckt.",
              "message": "Ihr Ansprechpartner wurde benachrichtigt."
            },
            "call-ping": {
              "title": "Sie haben erfolgreich eingecheckt.",
              "message": "Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."
            }
          },
          "Employee": {
            "title": "Sie haben erfolgreich eingecheckt.",
            "message": "Danke."
          },
          "Visitor": {
            "title": "Sie haben erfolgreich eingecheckt.",
            "message": "Danke."
          }
        },
        "checkout": {
          "default": {
            "title": "Sie haben erfolgreich ausgecheckt.<br/>",
            "message": "Bis bald."
          },
          "MeetingAttendee": {
            "title": "Sie haben erfolgreich ausgecheckt.",
            "message": "Bis bald."
          },
          "Employee": {
            "title": "Sie haben erfolgreich ausgecheckt.",
            "message": "Bis bald."
          },
          "Visitor": {
            "title": "Sie haben erfolgreich ausgecheckt.",
            "message": "Bis bald."
          }
        }
      }
    }
  },
  "manualCheckin": {
    "title": "Bitte füllen Sie das Formular aus.",
    "subtitle": "Hinweis - Alle Felder * müssen ausgefüllt werden",
    "noOption": "Keine Option",
    "btn": "Einchecken",
    "placeholder": {
      "name": "Ihr Name *",
      "email": "Ihre E-Mail *",
      "phone": "Handynummer",
      "contactName": "Name Ihres Ansprechpartners *"
    },
    "error": {
      "required": "Sie haben dieses Feld nicht ausgefüllt",
      "name": "Ungültiger Name",
      "email": "Ungültige E-Mail-Adresse",
      "phone": "Ungültige Handynummer"
    },
    "status": {
      "loading": {
        "title": "Bitte warten...",
        "message": "Ihr Ansprechpartner wird benachrichtigt."
      },
      "success": {
        "no-email-sms": {
          "title": "Sie haben erfolgreich eingecheckt.",
          "message": "Danke."
        },
        "email-sms": {
          "title": "Sie haben erfolgreich eingecheckt.",
          "message": "Ihr Ansprechpartner wurde benachrichtigt."
        },
        "call-ping": {
          "title": "Sie haben erfolgreich eingecheckt.",
          "message": "Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."
        }
      },
      "error": {
        "title": "Ein Fehler ist aufgetreten.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "manualCheckout": {
    "title": "Geben Sie Ihren Namen ein, um auszuchecken",
    "btn": "Auschecken",
    "form": {
      "placeholder": {
        "name": "Ihr vollständiger Name *"
      },
      "loading": "Laden...",
      "noOptions": "Keine Optionen"
    },
    "error": {
      "required": "Sie haben dieses Feld nicht ausgefüllt",
      "name": "Ungültiger Name"
    },
    "status": {
      "loading": {
        "title": "Wir scannen Ihre Informationen.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "Sie haben erfolgreich ausgecheckt.",
        "message": "Vielen Dank und einen schönen Tag."
      },
      "error": {
        "title": "Beim Auschecken ist ein Fehler aufgetreten.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Möchten Sie Ihren Ansprechpartner benachrichtigen?",
      "email-sms": "Wir haben Ihrem Ansprechpartner eine E-Mail/SMS gesendet.<br/>Möchten Sie ihn zusätzlich benachrichtigen?"
    },
    "callBtn": "Anrufen",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Videoanruf",
    "noBtn": "Abbrechen",
    "cancelBtn": "Anruf abbrechen",
    "status": {
      "connecting": {
        "title": "Anruf wird hergestellt.<br/>Bitte warten...",
        "message": ""
      },
      "ringing": {
        "title": "Ihr Ansprechpartner wird angerufen<br/>Bitte warten...",
        "message": ""
      },
      "ringingReception": {
        "title": "Rezeption wird angerufen.<br/>Bitte warten...",
        "message": ""
      },
      "open": {
        "title": "Anruf läuft.",
        "message": ""
      },
      "close": {
        "title": "Anruf beendet.<br/>Bitte warten Sie auf Ihren Ansprechpartner.",
        "message": ""
      },
      "closeReception": {
        "title": "Anruf ist beendet.",
        "message": ""
      },
      "error": {
        "title": "Anruf nicht hergestellt.<br/>Nochmals anrufen?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Wir benachrichtigen den Kontakt.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir benachrichtigen den Kontakt.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "SMS wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Vielen Dank!"
      },
      "error": {
        "title": "SMS wurde nicht gesendet.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "videoCall": {
    "title": "Videoanruf",
    "endCall": "ANRUF BEENDEN",
    "status": {
      "idle": {
        "title": "Wir erstellen einen Video-Raum.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir erstellen einen Video-Raum.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "Der Video-Raum wurde erfolgreich erstellt.",
        "message": "Betrete den Raum..."
      },
      "error": {
        "title": "Der Video-Raum konnte nicht erfolgreich erstellt werden.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "packageDelivery": {
    "title": "Wie schön, dass Sie ein Paket liefern!",
    "subtitle": "Wählen Sie den Empfänger und benachrichtigen Sie ihn",
    "subtitle1": "Drücken Sie den unten stehenden Knopf, um uns mitzuteilen, dass Sie hier sind!",
    "subtitle2": "Sie können das Paket am Empfang abgeben.",
    "input": {
      "label": {
        "contact": "Für wen ist das Paket"
      },
      "error": {
        "contact": {
          "required": "Sie haben dieses Feld nicht ausgefüllt"
        }
      }
    },
    "button": {
      "submit": "Benachrichtigen"
    },
    "status": {
      "loading": {
        "title": "Wir benachrichtigen den Kontakt.",
        "message": "Bitte warten..."
      },
      "success": {
        "no-email-sms": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": ""
        },
        "email-sms": {
          "title": "Der Kontakt wurde benachrichtigt.",
          "message": "Vielen Dank für Ihre Lieferung!"
        },
        "call-ping": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."
        }
      },
      "error": {
        "title": "Etwas ist schief gelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "foodDelivery": {
    "title": "Wie schön, dass Sie Essen liefern!",
    "subtitle": "Wählen Sie den Empfänger und benachrichtigen Sie ihn",
    "subtitle1": "Drücken Sie den unten stehenden Knopf, um uns mitzuteilen, dass Sie hier sind!",
    "subtitle2": "Sie können das Essen am Empfang abgeben.",
    "input": {
      "label": {
        "contact": "Für wen ist das Essen"
      },
      "error": {
        "contact": {
          "required": "Sie haben dieses Feld nicht ausgefüllt"
        }
      }
    },
    "button": {
      "submit": "Benachrichtigen"
    },
    "status": {
      "loading": {
        "title": "Wir benachrichtigen den Kontakt.",
        "message": "Bitte warten!"
      },
      "success": {
        "no-email-sms": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": ""
        },
        "email-sms": {
          "title": "Der Kontakt wurde benachrichtigt.",
          "message": "Vielen Dank für Ihre Lieferung!"
        },
        "call-ping": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Eine Telefonverbindung wird nun zu Ihrem Ansprechpartner hergestellt."
        }
      },
      "error": {
        "title": "Etwas ist schief gelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Bitte scannen Sie Ihren QR-Code",
    "subtitle": "Richten Sie den QR-Code innerhalb der roten Ecken aus und halten Sie Ihr Telefon ruhig."
  },
  "common": {
    "backBtn": "Zurück"
  },
  "previewPDF": {
    "page": {
      "of": "von",
      "previous": "Vorherige",
      "next": "Nächste"
    },
    "button": {
      "cancel": "Abbrechen",
      "accept": "Akzeptieren",
      "next": "Weiter"
    },
    "title": {
      "consent": "Einwilligung erforderlich"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "Die Rezeption ist momentan offline und kann nicht genutzt werden. Die Internetverbindung muss überprüft werden!",
    "check": "Sind Sie ein Besucher und möchten direkt mit einem Mitarbeiter sprechen? Bitte rufen Sie {{receptionistPhone}} an."
  },
  "overview": {
    "title": "Geben Sie den Code ein, um die Übersicht zu öffnen!",
    "noUsers": "Keine Benutzer",
    "status": {
      "success": {
        "title": "Der Code ist gültig.",
        "message": ""
      },
      "error": {
        "title": "Der Code ist ungültig.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Bitte warten...",
        "message": ""
      },
      "success": {
        "title": "Erfolgreich ausgecheckt.",
        "message": ""
      },
      "error": {
        "title": "Etwas ist schief gelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    },
    "listTitle": "Liste der Personen, die heute eingecheckt, aber nicht ausgecheckt haben",
    "page": "Seite ",
    "table": {
      "head": {
        "fullName": "Name",
        "type": "Typ",
        "checkedinAt": "Eingecheckt um",
        "host": "Gastgeber"
      },
      "type": {
        "Package": "Paketlieferung",
        "Food": "Essenslieferung",
        "Visitor": "Besucher",
        "MeetingAttendee": "Eingeladener Besucher",
        "Employee": "Mitarbeiter",
        "Guest": "Gast"
      }
    },
    "confirmModal": {
      "title": "Sind Sie sicher, dass Sie {{fullName}} auschecken möchten?",
      "cancel": "Abbrechen",
      "checkout": "Auschecken"
    }
  },
  "wifi": {
    "title": "Verbinden Sie sich mit dem WLAN-Netzwerk"
  }
}
